import { Stack } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { PublicHeader } from 'Components';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { BgDesk, BgMobile } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useEffect } from 'react';

export const OTPLoginLayout = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const otpData = useAppSelector(
    ({ otpLoginDetails: { otpLoginDetails } }) => otpLoginDetails
  );
  useEffect(() => {
    const token = otpData?.token || window.sessionStorage.getItem('token');

    if (token) {
      const payload = token.split('.')?.[1];
      const decodedPayload = JSON.parse(atob(payload));
      const expirationDate = new Date(decodedPayload.exp * 1000);
      const currentDate = new Date();
      if (expirationDate >= currentDate)
        navigate(Dictionary[DICTIONARY.General].universalRequestUrl);
    }
  }, [navigate, otpData?.token]);

  return (
    <div
      style={{
        backgroundImage: isDesktop ? `url(${BgDesk})` : `url(${BgMobile})`,
        backgroundSize: 'cover',
        fontFamily: 'Assistant',
      }}
    >
      <PublicHeader style={{ fontFamily: 'Assistant' }} />
      <Stack
        sx={{
          overflow: 'hidden',
          minHeight: '100vh',
          backgroundColor: '#F6F8FE',
          '&& *': { fontFamily: 'Assistant' },
        }}
        component={'main'}
      >
        <Outlet />
      </Stack>
    </div>
  );
};
